module.exports = __webpack_public_path__ + "img/icon_data2.d8818b8b.svg";